import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { budgetContactSubmit } from '../../../../../../reducers/budget';
import { formatPhoneNumber } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import RenderInput from '../../../../../common/components/render-input';
import SubmitButton, { onSubmit } from '../../../../../common/components/submit-button';
import LoadingState from '../../../../../common/components/loading';
import { formDetails as StepOneFormDetails } from '../step-one';
import { formDetails as AssessmentFormDetails } from '../assessment';
import { formDetails as SummaryFormDetails } from '../summary';

export const formName = Routes.CONTACTCOACH;

const tracking = {
    event: 'Form Submission',
    eventAction: 'Budget Calculator - Contact Coach',
    eventLabel: 'Contact a Coach'
};

const validate = values => v(values, {
    firstName: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        format: {
            pattern: /[A-Z.\-\s]+/i,
            message: 'can only contain letter, periods or hyphens'
        }
    },
    lastName: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        format: {
            pattern: /[A-Z.\-\s]+/i,
            message: 'can only contain letter, periods or hyphens'
        }
    },
    email: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        email: {
            message: 'needs to be a valid email'
        }
    },
    phone: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        format: {
            pattern: /[0-9()\-\s]+/i,
            message: 'can only contain numbers, brackets and hyphens'
        },
        length: {
            is: 14,
            wrongLength: 'must be 10 digits'
        }
    }
});

class ContactForm extends Component {
    render() {
        const {
            props: {
                formLoading,
                formError
            }
        } = this;

        const loading = formLoading && !formError;

        return (
            <form method='post' className={styles.form}>
                {
                    loading &&
                    <LoadingState title='Submitting Form'/>
                }
                {
                    !loading &&
                    <div>
                        <Field
                            name='firstName'
                            label='First Name'
                            autoComplete='given-name'
                            component={RenderInput}
                        />
                        <Field
                            name='lastName'
                            label='Last Name'
                            autoComplete='family-name'
                            component={RenderInput}
                        />
                        <Field
                            type='email'
                            name='email'
                            label='Email Address'
                            autoComplete='email'
                            component={RenderInput}
                        />
                        <Field
                            type='tel'
                            name='phone'
                            label='Phone Number'
                            autoComplete='tel-national'
                            format={formatPhoneNumber}
                            component={RenderInput}
                        />
                        <SubmitButton form={formName} className={styles.button}>Contact a Coach</SubmitButton>
                    </div>
                }
                {
                    formError &&
                    <p className={styles.errorMessage}>There seems to be an error with the form. Please try again later.</p>
                }
            </form>
        );
    }
}

ContactForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    redirectPath: `/budget-planner${Routes.THANKYOUCOACH}`,
    dispatchFunction: budgetContactSubmit,
    tracking: () => trackingEvent(tracking)
})(ContactForm);

const AssessmentFormValues = getFormValues(AssessmentFormDetails.formName);
const SummaryFormValues = getFormValues(SummaryFormDetails.formName);

export default withRouter(connect((state) => {
    if (!SummaryFormValues(state)) {
        return state;
    }

    const summaryData = SummaryFormValues(state);
    const assessmentData = AssessmentFormValues(state);
    const expensesSummary = summaryData[SummaryFormDetails.summaryFieldsKey].filter(({key}) => key !== StepOneFormDetails.key);

    return {
        formLoading: state.budget.isLoading,
        formError: state.budget.hasError,
        token: state.auth.token,
        sendLeadsEmail: true,
        formValues: {
            ...assessmentData,
            [SummaryFormDetails.summaryFieldsKey]: [
                ...expensesSummary
            ]
        }
    }
})(ContactForm));
